import type { Recommendations } from 'shared';
import { ACTIVITY_TYPE_LABELS, BADGE_UNIVERSO_COLORS } from 'shared';
import { cardSubtitle, nextSession, reasonText } from '@/lib/recommendations';

/** "Sugestões para si": activities to try next, from what similar Diggers did. */
export default function RecommendationsCard({ data }: { data: Recommendations }) {
  return (
    <section aria-labelledby="sugestoes-heading" className="rounded-2xl border border-primary/20 bg-card p-4 shadow-sm">
      <h2 id="sugestoes-heading" className="text-sm font-black text-primary">
        Sugestões para si
      </h2>
      <p className="mt-0.5 text-xs text-muted-foreground">{cardSubtitle(data)}</p>
      <ul className="mt-3 space-y-3">
        {data.suggestions.map((r) => (
          <li key={r.activityId} className="flex items-start gap-3">
            <span
              className="mt-1 h-3 w-3 flex-shrink-0 rounded-[4px] bg-primary"
              style={r.universo ? { backgroundColor: BADGE_UNIVERSO_COLORS[r.universo].bg } : undefined}
              aria-hidden="true"
            />
            <div className="min-w-0">
              <p className="text-sm font-bold text-foreground">{r.name}</p>
              <p className="text-xs text-muted-foreground">
                {[ACTIVITY_TYPE_LABELS[r.type], r.universo, r.digitalCenterName].filter(Boolean).join(' · ')}
              </p>
              <p className="text-xs text-muted-foreground">Próxima sessão: {nextSession(r.nextSessionAt)}</p>
              <p className="mt-1 text-xs text-foreground">{reasonText(r)}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
